import { useSelector } from "react-redux";
import { selectResetEmailAddress } from "./ForgotPasswordPageSlice";

export const PasswordResetConfirmation: React.FC = () => {
  const resetEmailAddress = useSelector(selectResetEmailAddress);
  return (
    <>
      {/* begin::Form group */}
      <div className="fv-row mb-10">
        <div className="fw-bold fs-5">
          A password reset link has been sent to <i>{resetEmailAddress}</i>, if this email address is registered with an
          account.
        </div>
      </div>
      {/* end::Form group */}
    </>
  );
};
